module.exports = __webpack_public_path__ + "static/home-banner-03-6b2a0c0097f6bd4020943275eda3981b.jpg";